import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './styles.scss'

import { Grid, Input } from 'react-spreadsheet-grid'

const SPACE_CHAR = ' '
const NEWLINE_CHAR = '\n'
const CELL_STYLES = ['SpreadsheetGrid__cell_active', 'SpreadsheetGrid__cell_focused']

export class DataSourceSpreadsheet extends Component {
  constructor (props) {
    super(props)
    this.state = {
      blurCurrentFocus: false
    }
    this.activeElement = null
  }

  componentDidMount () {
    this.getProperties(true)
    window.onresize = this.getProperties
    document.addEventListener('focus', this.getFocus, true)
    document.addEventListener('keydown', this.handleKeyDown)
  }

  componentDidUpdate () {
    this.getProperties(false)
  }

  componentWillUnmount () {
    window.onresize = null
    document.removeEventListener('focus', this.getFocus, true)
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  handleKeyDown = evt => {
    const id = evt.target.getAttribute('id')
    if (id === 'ds-name-editor' || id === 'column-input') return
    evt.stopImmediatePropagation()
    if (!this.activeElement) return
    if (evt.key === 'Enter' && evt.target.getAttribute('id') !== 'extended-field') {
      this.spreadsheetKeys(true)
    } else if (evt.key === 'Tab') {
      evt.preventDefault()
      this.spreadsheetKeys(false)
    }
  }

  spreadsheetKeys = isEnter => {
    const { columns } = this.props
    const currentIndex = Number(this.activeElement.getAttribute('data-cell'))

    let nextFocus
    if (isEnter) {
      nextFocus = document.querySelector(`[data-cell='${currentIndex + columns.length}']`)
      if (!nextFocus) return
    } else {
      nextFocus = document.querySelector(`[data-cell='${currentIndex + 1}']`)
      if (!nextFocus) return
    }

    nextFocus.parentElement.classList.add(...CELL_STYLES)
    this.activeElement.parentElement.classList.remove(...CELL_STYLES)
    const activeInput = nextFocus.querySelector('input')
    activeInput.focus()
    this.activeElement = nextFocus
    this.props.extendedField(activeInput) 
  }

  getFocus = evt => {
    if (evt.target.className !== 'SpreadsheetGridInput' || evt.relatedTarget) {
      return
    }
    if (this.activeElement) {
      this.activeElement.parentElement.classList.remove(...CELL_STYLES)
    }
    this.activeElement = evt.target.parentElement
    this.props.extendedField(evt.target)
  }

  getProperties = initial => {
    const { scroll: { x, y } } = this.props
    const target = document.querySelector('.SpreadsheetGridScrollWrapper_scrollable')
    const reference = document.getElementById('widthReference')
    const header = document.querySelector('.SpreadsheetGrid__header')
    if (initial) {
      target.scrollTop = y
      reference.scrollLeft = x
    }
    target.style.width = `${reference.scrollWidth}px`
    header.style.width = `${reference.scrollWidth}px`
  }

  onFieldChange (rowId, field, value) {
    this.props.onFieldChange(rowId, field, value)
    this.setState({
      blurCurrentFocus: true
    })
  }

  handleAddSelected = evt => {
    const index = evt.target.getAttribute('data-index')
    this.props.onRowSelection(index)
  }

  handleExtendedInput = (value = '', charToReplace, charToAdd) => {
    let newValue = ''
    for (const char of value) {
      if (char === charToReplace) newValue += charToAdd
      else newValue += char
    }
    return newValue
  }

  getColumns () {
    let columnNames = this.props.columns

    if (!columnNames) {
      const firstRow = this.props.rows[0]
      if (!firstRow) {
        return []
      }
      columnNames = Object.keys(firstRow)
    }

    const columns = []
    columns.push({
      title: () => {
        return <span />
      },
      value: (row) => {
        return (
          <input
            type='checkbox'
            className={css.checkbox}
            data-index={row._index}
            data-checkbox
            checked={row._checked}
            onChange={this.handleAddSelected}
          />
        )
      }
    })
    for (let i = 0; i < columnNames.length; i++) { // eslint-disable-line no-unused-vars
      const col = columnNames[i]
      if (col.startsWith('_')) continue

      columns.push({
        title: () => {
          return (
            <div className={css.columnWrapper}>
              <span className={css.columnValue}>{col}</span>
              <span className={css.deleteColumn} onClick={() => this.props.onDeleteColumn(col)}>X</span>
            </div>
          )
        },
        value: (row, { focus }) => {
          const attributes = {}
          const cellIndex = i + (row._index * columnNames.length)

          if (this.props.onFieldChange) {
            attributes.onChange = this.onFieldChange.bind(this, row._index, col)
          }
          const newValue = this.handleExtendedInput(row[col], NEWLINE_CHAR, SPACE_CHAR)
          return (
            <div className={css.inputWrapper} data-row={row._index} data-column={col} data-cell={cellIndex}>
              <Input
                value={newValue}
                focus={focus}
                {...attributes}
              />
            </div>
          )
        }
      })
    }
    return columns
  }

  render () {
    const { blurCurrentFocus } = this.state
    const { rows } = this.props
    const columns = this.getColumns()

    return (
      <Grid
        columns={columns}
        rows={rows}
        getRowKey={row => row._index}
        blurCurrentFocus={blurCurrentFocus}
        placeholder='There are no columns.'
        focusOnSingleClick
      />
    )
  }
}

const mapStateToProps = state => {
  const { auth } = state
  return {
    auth
  }
}

export default connect(mapStateToProps)(DataSourceSpreadsheet)



// WEBPACK FOOTER //
// /app/js/components/DataSourceSpreadsheet/index.js